import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IstanzaQuestionarioCompleto } from '../../../../core/api/models/istanzaQuestionarioCompleto.model';

import {
  ApiService,
  NotificationService,
  ROUTE_ANIMATIONS_ELEMENTS
} from '../../../../core/core.module';
import { DomandaRadio } from './domandaRadio';

@Component({
  selector: 'mydyn-questionario',
  templateUrl: './questionario.component.html',
  styleUrls: ['./questionario.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionarioComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  appLoading = false;
  istanzaQuestionario: IstanzaQuestionarioCompleto;
  formQuestionario: FormGroup;
  domande: DomandaRadio[] = [];

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private cd: ChangeDetectorRef,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.appLoading = true;
    this.route.parent.params.subscribe((params) => {
      this.apiService
        .getIstanzaQuestionarioDomandeDaCompilareByPratica(+params['id'])
        .subscribe(response => {
          if (response !== null) {
            this.istanzaQuestionario = response;
            this.istanzaQuestionario.domande.forEach((domanda) => {
              let options: { key: number; value: string }[] = [];
              domanda.rispostas.forEach((risposta) => {
                options = options.concat({
                  key: risposta.rspId,
                  value: risposta.rspTesto
                });
              });
              this.domande = this.domande.concat(
                new DomandaRadio({
                  key: domanda.dmnId,
                  label: domanda.dmnTesto,
                  required: true,
                  order: domanda.dmnOrdinamento,
                  options: options
                })
              );
            });
            this.formQuestionario = this.creaFormGroup(this.domande);
          }
          this.appLoading = false;
          this.cd.detectChanges();
        });
    });
  }

  creaFormGroup(domande: DomandaRadio[]) {
    const group: any = {};

    domande.forEach((domanda) => {
      group[domanda.key] = domanda.required
        ? new FormControl(domanda.value || '', Validators.required)
        : new FormControl(domanda.value || '');
    });
    return new FormGroup(group);
  }

  inviaQuestionario() {
    this.appLoading = true;
    this.istanzaQuestionario.domande.forEach((domanda) => {
      domanda.rispostas = domanda.rispostas.filter(
        (risposta) =>
          risposta.rspId === this.formQuestionario.value[domanda.dmnId]
      );
    });
    this.apiService
      .saveOrUpdateIstanzaQuestionario(this.istanzaQuestionario)
      .subscribe(response => {
        if (response) {
          // TODO: Implementare redirect dopo invio questionario
          // tutto ok, visualizza conferma e redirect al dettaglio pratica?
        } else {
          this.notificationService.error(
            'Errore durante l\'invio del questionario'
          );
        }
      });
    this.appLoading = false;
    this.cd.detectChanges();
  }
}
